interface MainComponentProps {
    children: JSX.Element | undefined
}

const MainComponent = ({ children }: MainComponentProps) => {
    return <div className='mainComponent'>{children}</div>
}

export default MainComponent
